import { render, staticRenderFns } from "./credential.vue?vue&type=template&id=99d04e04&scoped=true&"
import script from "./credential.vue?vue&type=script&lang=js&"
export * from "./credential.vue?vue&type=script&lang=js&"
import style0 from "./credential.vue?vue&type=style&index=0&id=99d04e04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d04e04",
  null
  
)

export default component.exports